import lity from 'lity';

[ ...document.querySelectorAll('a[data-srcset]') ].forEach( link => {
    var srcset = link.dataset.srcset;
    link.addEventListener('click', () => {
        var lightbox = lity(`<img srcset="${srcset}"/>`);
        lightbox.element()[ 0 ].addEventListener('click', () => lightbox.close() );
    });
})